import React, { useState, useEffect } from 'react';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import cookies from 'js-cookie';
import {
  IconButton,
  Tooltip,
  Menu,
  MenuItem,
  Grid,
  Typography,
} from '@material-ui/core';
import LanguageIcon from '@material-ui/icons/Language';
import { makeStyles } from '@material-ui/core/styles';
import { decodeToken } from '../../utils';
import Logout from './Logout';
import ToggleDark from './ToggleDark';
import { Settings } from '@material-ui/icons';
import CustomButton from 'components/Button';
import { Form, Modal } from 'antd';
import FloatInput from 'components/Input';
import {
  changeEmailAction,
  refreshTokenAction,
} from 'redux/actions/authAction';
import { useDispatch, useSelector } from 'react-redux';
import Tabs from 'components/Tabs';
import CustomSelect from 'components/Select';
import { changePreferredLanguageAction } from 'redux/actions/settingsAction';
import Button from 'components/Button';
import { isMobile } from 'react-device-detect';

const useStyles = makeStyles(() => ({
  loggedIn: {
    color: '#000',
    fontFamily: 'Poppins',
  },
}));

const languages = [
  { code: 'fr', name: 'Français', country_code: 'fr' },
  { code: 'en', name: 'English', country_code: 'gb' },
  { code: 'rw', name: 'Ikinyarwanda', country_code: 'rw' },
];

const Language = ({ darkMode, setDarkMode }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const currentLanguageCode = cookies.get('i18next') || 'en';
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [activeTab, setActiveTab] = useState(1);
  const [activeLanguage, setActiveLanguage] = useState(
    cookies.get('i18next') || 'en'
  );

  const { changedEmail, preferredLanguage } = useSelector(
    ({ auth, settings }) => ({
      changedEmail: auth.changedEmail,
      preferredLanguage: settings.preferredLanguage,
    })
  );

  useEffect(() => {
    if (
      changedEmail?.status === 'success' ||
      preferredLanguage?.status === 'success'
    ) {
      setOpenModal(false);
    }
  }, [changedEmail, preferredLanguage]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const changeLanguage = (code) => {
    i18next.changeLanguage(code);
    setAnchorEl(null);
    window.location.reload();
  };

  const handleChange = () => {
    form.validateFields().then((payload) => {
      if (activeTab === 1) {
        delete payload.preferredLanguage;
        changeEmailAction(payload)(dispatch);
      } else {
        delete payload.email;
        i18next.changeLanguage(payload.preferredLanguage);
        changePreferredLanguageAction(payload)(dispatch);
        refreshTokenAction()(dispatch);
      }
    });
  };

  const userSettings = [
    {
      key: 1,
      label: 'Account Settings',
      children: (
        <Form
          form={form}
          initialValues={{ email: decodeToken()?.email }}
          className='my-3'
        >
          <Form.Item name='email'>
            <FloatInput
              label='Email Address'
              placeholder='yourname@example.com'
              disabled={decodeToken()?.userRole?.RoleName !== 'Applicant'}
            />
          </Form.Item>
        </Form>
      ),
    },
    {
      key: 2,
      label: 'Preferences',
      children: (
        <Form
          form={form}
          initialValues={{ preferredLanguage: cookies.get('i18next') }}
          className='my-3'
        >
          <Form.Item name='preferredLanguage'>
            <CustomSelect
              label='Preferred Language'
              options={[
                { label: 'Ikinyarwanda', value: 'rw' },
                { label: 'English', value: 'en' },
                { label: 'Francais', value: 'fr' },
              ]}
              defaultFocus={true}
              defaultValue={cookies.get('i18next')}
            />
          </Form.Item>
        </Form>
      ),
    },
  ];

  return (
    <div>
      <Modal
        open={openModal}
        onOk={handleChange}
        okText='Change'
        onCancel={() => setOpenModal(false)}
        confirmLoading={changedEmail?.loading || preferredLanguage?.loading}
      >
        <Tabs items={userSettings} onChange={(key) => setActiveTab(key)} />
      </Modal>
      <Grid container spacing={2} alignItems='center'>
        <Grid item>
          {/* <ToggleDark darkMode={darkMode} setDarkMode={setDarkMode} /> */}
        </Grid>
        <Grid
          item
          className='d-flex justify-content-center align-items-center mt-3'
        >
          <CustomSelect
            options={languages?.map(({ code, name, country_code }, key) => ({
              label: (
                <div key={code}>
                  <span className={`flag-icon flag-icon-${country_code}`} />{' '}
                  <label> {name}</label>
                </div>
              ),
              value: code,
            }))}
            onChange={changeLanguage}
            defaultValue={activeLanguage}
            size='small'
            bordered={false}
            style={{ width: 150 }}
          />
        </Grid>
        {decodeToken() !== undefined && decodeToken().id ? (
          <>
            <Grid item>
              {!isMobile && (
                <Typography variant='body2' className={classes.loggedIn}>
                  {decodeToken().firstName} {decodeToken().lastName}
                </Typography>
              )}
              <label>
                {!isMobile && (
                  <small>
                    {decodeToken().userRole?.RoleName}{' '}
                    {decodeToken().adminProfile &&
                      ' - ' + decodeToken().adminProfile?.organization}
                  </small>
                )}
                <Settings
                  className={isMobile && 'mt-3'}
                  role='button'
                  onClick={() => setOpenModal(true)}
                />{' '}
              </label>
            </Grid>
            {!isMobile && (
              <Grid item>
                <Typography variant='body2' component='div'>
                  <Logout />
                </Typography>
              </Grid>
            )}
          </>
        ) : (
          ''
        )}
      </Grid>
    </div>
  );
};

export default Language;
